export default function setDropMenu() {

  /* Element */
  const categoryElm = document.getElementById('js-dropMenuCategory');
  const targetElm = document.querySelectorAll('.js-dropMenu');
  const allElm = document.querySelectorAll('.js-dropMenuAll');
  const optionElm = document.querySelectorAll('.js-dropMenuOption');
  const btnElm = document.querySelectorAll('.js-dropMenuTrigger');
  const labelAry = [];
  btnElm.forEach(elm => {
    let label = elm.textContent;
    labelAry.push(label)
  });

  /* click */
  targetElm.forEach(targetElm => {
    targetElm.addEventListener('click', (e) => {
      remove();
      e.target.classList.add('is-open');
    })
  });

  /* ALL選択時、デフォルトにcategoryを戻す */
  allElm.forEach(allElm => {
    allElm.addEventListener('click', () => {
      remove();
      categoryElm.innerHTML = 'CATEGORY';
      targetElm[0].classList.remove('is-sort');
    })
  });

  /* 選択したエレメントを見出しに入れる */
  optionElm.forEach(optionElm => {
    optionElm.addEventListener('click', (e) => {
      labelClear();
      let dataCat = e.target.getAttribute('data-cat');
      let txtCat = e.target.textContent;
      let listTsg = e.target.closest('li').querySelector('span');
      listTsg.innerHTML = txtCat;
      targetElm[0].classList.add('is-sort');
      remove();
    })
  });

  /* ESC処理 */
  window.addEventListener('keyup', function (e) {
    if (e.keyCode == 27) {
      remove();
    }
  });

  /* ラベルを元に戻す */
  const labelClear = () => {
    for (let index = 0; index < btnElm.length; index++) {
      btnElm[index].innerHTML = labelAry[index];
    };
  };

  /* class削除 */
  const remove = () => {
    Array.from(targetElm).forEach(targetElm => {
      targetElm.classList.remove('is-open');
    });
  }

}